module.exports = __webpack_public_path__ + "static/media/ClearSun01d.b2bb4a01.png";